import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import * as service from "../../../../store/service";
import { Notification } from "../../../common/Notification";
import { useDispatch, useSelector } from "react-redux";
import * as ProtectionPlanActions from "../../../../store/protectionPlanService/idf/actions";

import { PATTERNS } from "../../../../util/patterns";
import i18nService from "../../../../util/Internationalization/i18n/i18n";
import { validateCardExpiry } from "../../../../util/common";
import { ApplicationState } from "../../../../store";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { stateList } from "../../../../util/CommonLists";
import { CAProvinces } from "../../../../util/CommonLists";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { isValidPhoneNo } from "../../../../util/phoneNumberValidationUtil";
import * as httpClient from "../../../../util/httpClient";

interface IProps {
    setShowForm: any;
    billingInfo: any;
    IsIDFUser: any;
    setEFTDialog: any;
    contactInfo: any;
    setBillingInfo: any;
    setHasbillingInfo: any;
}

const IDFBillingInformationForm = ({ setShowForm, billingInfo, IsIDFUser, setEFTDialog, contactInfo, setBillingInfo, setHasbillingInfo }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [isETF, setIsETF] = useState(false);
    const [state, setState] = useState({ cardType: "" });
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isSameAsContactAddress, setIsSameAsContactAddress] = useState(false);
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    const [enableBillingAddressForRecurly, setEnableBillingAddressForRecurly] = useState(false);
    const country = i18nService.get("Country");
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const { t: tLang } = useTranslation();
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const { register, handleSubmit, errors, setValue, clearErrors, control, watch } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const dispatch = useDispatch();
    const requestBillingInfo = (forceLoad: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestBillingInfo(forceLoad));

    const getAccountOrCardType = () => {
        let accountOrCardType = "";
        if (isETF) {
            accountOrCardType =
                billingInfo && billingInfo.eft && billingInfo.eft.accountType && billingInfo.eft.accountType.selection ? billingInfo.eft.accountType.selection : "";
        } else {
            accountOrCardType =
                billingInfo && billingInfo.creditCard && billingInfo.creditCard.cardType && billingInfo.creditCard.cardType.selection
                    ? billingInfo.creditCard.cardType.selection
                    : "";
            const cardTypeKeyValue = [
                { key: "VISA", value: "Visa" },
                { key: "MASTERCARD", value: "Mastercard" },
                { key: "DISCOVER", value: "Discover" },
                { key: "AMEX", value: "American Express" },
            ];
            const cardObjectWithKeyValue = cardTypeKeyValue.find((card) => card.key === accountOrCardType || card.value === accountOrCardType);
            if (cardObjectWithKeyValue) {
                accountOrCardType = cardObjectWithKeyValue.key;
            }
        }
        return accountOrCardType;
    };

    const getCashholderName = () => {
        let cashholderName = "";
        cashholderName = billingInfo && billingInfo.creditCard && billingInfo.creditCard.nameOnCard ? billingInfo.creditCard.nameOnCard : "";
        return cashholderName;
    };

    const getSecurityCode = () => {
        let code = "";
        code = billingInfo && billingInfo.creditCard && billingInfo.creditCard.securityCode ? billingInfo.creditCard.securityCode : "";
        return code;
    };

    const getZipCode = () => {
        let code = "";
        code = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.zipCode ? billingInfo.billingAddress.zipCode : "";
        return code;
    };

    const getAddress1 = () => {
        let address = "";
        address = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.address1 ? billingInfo.billingAddress.address1 : "";
        return address;
    };

    const getAddress2 = () => {
        let address = "";
        address = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.address2 ? billingInfo.billingAddress.address2 : "";
        return address;
    };

    const getCity = () => {
        let address = "";
        address = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.city ? billingInfo.billingAddress.city : "";
        return address;
    };

    const getState = () => {
        let country = "";
        country =
            billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.state && billingInfo.billingAddress.state.selection
                ? billingInfo.billingAddress.state.selection
                : "";
        return country;
    };

    const validateCreditCardNumber = {
        invalid: (val: any) => {
            if (state.cardType === "AMEX") {
                return /^$|^(\d{15})$/.test(val);
            }
            return /^$|^(\d{16})$/.test(val);
        },
    };

    const populateNewBillingInfo = () => {
        service
            .GetPaymentDetail()
            .then((data) => {
                setLoading(false);
                setShowForm(false);
                if (data.isSuccess) {
                    setBillingInfo(data);
                    if (data.paymentMethod && data.paymentMethod.selection) {
                        setHasbillingInfo(true);
                    }
                }
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const clearInvalidBillingAddress = () => {
        if (errors && errors.billingAddress) {
            clearErrors("billingAddress");
        }
    };

    const changeSameAsContactAddress = () => {
        clearInvalidBillingAddress();
        if (isSameAsContactAddress) {
            setIsSameAsContactAddress(false);
            return;
        }
        setIsSameAsContactAddress(true);
    };

    const formatePhoneNumber = (phoneNumber: string) => {
        let phoneNumberWithoutMasking = phoneNumber;
        phoneNumberWithoutMasking = phoneNumberWithoutMasking?.replace(" ", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking?.replace("(", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking?.replace(")", "");
        phoneNumberWithoutMasking = phoneNumberWithoutMasking?.replace("-", "");
        return phoneNumberWithoutMasking;
    };

    const getRequestBillingAddress = (data: any) => {
        const address1 = isSameAsContactAddress ? contactInfo.address1 : data.address1;
        const address2 = isSameAsContactAddress ? contactInfo.address2 : data.address2;
        const zipcode = isSameAsContactAddress ? contactInfo.zipCode : data.zipcode;
        const state = isSameAsContactAddress ? contactInfo.state : data.state;
        const city = isSameAsContactAddress ? contactInfo.city : data.city;
        const phone = isSameAsContactAddress && contactInfo.phoneNumber ? formatePhoneNumber(contactInfo.phoneNumber) : formatePhoneNumber(data.phone);

        const billingAddress = {
            Address1: address1,
            Address2: address2,
            City: city,
            State: {
                Selection: state,
            },
            ZipCode: zipcode,
            Phone: phone,
        };
        return billingAddress;
    };

    const onSubmit = (data: any) => {
        const expDate = data.expirationDate.split("/");
        let requestBody = {
            creditCardDetails: {
                cardType: {
                    options: [data.cardType],
                    readOnly: true,
                },
                nameOnCard: data.cardholderName?.trimStart(),
                cardNumber: data.cardNumber,
                expDateMo: expDate[0],
                expDateYr: expDate[1],
                securityCode: data.securityCode,
                billingZip: data.zipcode,
            },
            BillingAddress: getRequestBillingAddress(data)
        };

        setLoading(true);
        service
            .saveBillingInfo(requestBody)
            .then((data) => {
                if (data.isSuccess) {
                    requestBillingInfo(true);
                    populateNewBillingInfo();

                    Notification({
                        type: "success",
                        title: "Billing Information",
                        message: "Billing Information Successfully Saved.",
                        duration: 5,
                    });
                } else if (data.hasError && data.errors && data.errors.length > 0) {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Billing Information",
                        message: data.errors[0],
                        duration: 5,
                    });
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Billing Information",
                        message: "Could not save billing information. Please try again later.",
                        duration: 5,
                    });
                }
            })
            .catch(() => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: "Billing Information",
                    message: "Could not save billing information. Please try again later.",
                    duration: 5,
                });
            });
    };

    const changeCardType = (event: any) => {
        setState({
            ...state,
            cardType: event.target.value,
        });
        setValue("cardNumber", "");
        setValue("securityCode", "");
    };

    let expirationDateFieldPressedKey: number;
    const updateExpirationDatePressedKey = (e: any) => {
        expirationDateFieldPressedKey = e.keyCode;
    };
    const toaddMaskToExpiartionDate = (e: any) => {
        e.preventDefault();
        if (e.target.value.length === 2 && expirationDateFieldPressedKey !== 8 && expirationDateFieldPressedKey !== 46) {
            e.target.value = e.target.value + "/";
        }
    };

    const validateSecurityCode = {
        invalid: (val: any) => {
            if (state.cardType === "AMEX") {
                return /^$|^(\d{4})$/.test(val);
            }
            return /^$|^(\d{3})$/.test(val);
        },
    };

    useEffect(() => {
        if (billingInfo && billingInfo.paymentMethod && billingInfo.paymentMethod.selection && billingInfo.paymentMethod.selection === "EFT") {
            setIsETF(true);
        } else {
            setIsETF(false);
        }

        const phone = billingInfo && billingInfo.billingAddress && billingInfo.billingAddress.phone ? billingInfo.billingAddress.phone : "";
        setPhoneNumber(phone);
        httpClient.sendRequest("GET", `api/billing-info/get-enabled-billing-address-flag-for-recurly`).then((data: any) => {
            setEnableBillingAddressForRecurly(data);
        })
    }, []);
    
    return (
        <div id="billing-info-form" className={`${loading && "loading"}`}>
            <form onSubmit={handleSubmit(onSubmit)} id="billing-info-form-container">
                <div className={`form-row inline row ${errors["cardholderName"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="label-cardholderName">
                            Cardholder Name{" "}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            type="text"
                            name="cardholderName"
                            defaultValue={getCashholderName()}
                            className="inputbox"
                            id="label-cardholderName"
                            ref={register({ required: true, pattern: PATTERNS.CARDHOLDERNAME.pattern, maxLength: 30 })}
                            maxLength={30}
                            placeholder=""
                            aria-required="true"
                        />
                        {errors["cardholderName"] && errors["cardholderName"].type === "required" && (
                            <span className="form-error">Cardholder Name is required.</span>
                        )}
                        {errors["cardholderName"] && errors["cardholderName"].type === "pattern" && (
                            <span className="form-error">{PATTERNS.CARDHOLDERNAME.message}</span>
                        )}
                        {errors["cardholderName"] && errors["cardholderName"].type === "maxLength" && (
                            <span className="form-error">Cardholder name must be less than 30 characters length.</span>
                        )}
                    </div>
                </div>

                <div className={`form-row inline row ${errors["cardType"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="edit-card-type">
                            Card Type{" "}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <select
                            ref={register({ required: true })}
                            className={errors.cardType ? "status-error inputbox" : "inputbox"}
                            id="edit-card-type"
                            aria-labelledby="edit-card-type"
                            name="cardType"
                            defaultValue={getAccountOrCardType()}
                            onChange={changeCardType}
                            aria-required="true"
                        >
                            <option value="">Choose Type</option>
                            <option value="VISA">Visa</option>
                            <option value="MASTERCARD">Mastercard</option>
                            <option value="DISCOVER">Discover</option>
                            <option value="AMEX">American Express</option>
                        </select>

                        {errors.cardType && (
                            <span className="form-error">
                                <p>Card Type is required.</p>
                            </span>
                        )}
                    </div>
                </div>

                <div className={`form-row inline row ${errors["cardNumber"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="label-card-number">
                            Card Number{" "}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            type="text"
                            name="cardNumber"
                            defaultValue=""
                            className="inputbox"
                            id="label-card-number"
                            ref={register({ required: true, validate: validateCreditCardNumber })}
                            maxLength={state.cardType === "AMEX" ? 15 : 16}
                            placeholder="Card Number"
                            aria-required="true"
                        />
                        {errors["cardNumber"] && errors["cardNumber"].type === "required" && <span className="form-error">Card Number is required.</span>}
                        {errors["cardNumber"] && errors["cardNumber"].type === "pattern" && <span className="form-error">A valid card number is required.</span>}
                        {errors["cardNumber"] && errors["cardNumber"].type === "invalid" && (
                            <span className="form-error">
                                A valid card number is required. Card number should be of {state.cardType === "AMEX" ? "15" : "16"} digit
                            </span>
                        )}
                    </div>
                </div>

                <div className={`form-row inline row ${errors["expirationDate"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="label-expiration-date">
                            Expiration Date{" "}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            type="text"
                            name="expirationDate"
                            defaultValue=""
                            className="inputbox"
                            id="label-expiration-date"
                            ref={register({
                                required: true,
                                maxLength: 5,
                                pattern: /(0[1-9]|1[012])[/]([0-9][1-9]|[1-9][0-9])/,
                                validate: (value) => {
                                    if (value.length === 5) {
                                        const expireDate = value.split("/");
                                        return validateCardExpiry(expireDate[0], expireDate[1]);
                                    }
                                    return true;
                                },
                            })}
                            placeholder="MM/YY"
                            maxLength={5}
                            onKeyDown={updateExpirationDatePressedKey}
                            onChange={toaddMaskToExpiartionDate}
                            aria-required="true"
                        />
                        {errors["expirationDate"] && errors["expirationDate"].type === "required" && (
                            <span className="form-error">Expiration Date is required.</span>
                        )}
                        {errors["expirationDate"] && errors["expirationDate"].type === "maxLength" && (
                            <span className="form-error">Maximum length for Expiration Date is 5.</span>
                        )}
                        {errors["expirationDate"] && errors["expirationDate"].type === "pattern" && (
                            <span className="form-error">Expiration date must contain a valid 2-digit month and 2-digit year.</span>
                        )}
                        {errors["expirationDate"] && errors["expirationDate"].type === "validate" && (
                            <span className="form-error">{`Invalid expiry date. If you continue to have this issue please call ${partnerPhoneNumber}.`}</span>
                        )}
                    </div>
                </div>
                <div className={`form-row inline row ${errors["securityCode"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="label-security-code">
                            Security Code{" "}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            type="password"
                            name="securityCode"
                            defaultValue={getSecurityCode()}
                            className="inputbox"
                            id="label-security-code"
                            ref={register({ required: true, validate: validateSecurityCode })}
                            maxLength={state.cardType === "AMEX" ? 4 : 3}
                            placeholder="CVV"
                            aria-required="true"
                        />
                        {errors["securityCode"] && errors["securityCode"].type === "required" && <span className="form-error">Security Code is required.</span>}
                        {errors["securityCode"] && errors["securityCode"].type === "invalid" && (
                            <span className="form-error">
                                Invalid Credit Card Security Code. Security Code should be of {state.cardType === "AMEX" ? "4" : "3"} digit
                            </span>
                        )}
                    </div>
                </div>
                {!enableBillingAddressForRecurly && (
                    <div className={`form-row inline row ${errors["zipcode"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-address-zipcode">
                                {zipCode.Label}{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span> &nbsp;
                            </label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <input
                                type="text"
                                className="inputbox"
                                id="label-address-zipcode"
                                defaultValue={getZipCode()}
                                name="zipcode"
                                maxLength={zipCode.MaxLength}
                                placeholder={zipCode.Label}
                                ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern })}
                                aria-required="true"
                            />
                            {errors["zipcode"] && errors["zipcode"].type === "required" &&
                                <span className="form-error">
                                    {zipCode.Label === "Zip Code"
                                        ? tLang("manageAccount.myAccount.billing.address.validations.zip.required")
                                        : tLang("manageAccount.myAccount.billing.address.validations.postalCode.required")}
                                </span>
                            }
                            {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                <span className="form-error">
                                    {tLang("manageAccount.myAccount.billing.address.validations.zip.invalid")} {zipCode.Label}{" "}
                                    {tLang("manageAccount.myAccount.billing.address.validations.zip.pattern")}
                                </span>
                            )}
                        </div>
                    </div>
                )}
                

                {enableBillingAddressForRecurly && (
                    <>
                        <div className="margin-vertical-l"></div>
                        <div className="form-row inline row">
                            <div className="form-label col-xs-12 col-sm-8 col-no-gutter">
                                <div className="line-divider" style={{ marginTop: "1.5rem" }}></div>
                            </div>
                        </div>
                        <div className="box" style={{ marginLeft: "2rem" }}>
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-icon" aria-hidden="true">
                                        <RenderIcons iconName="map-marker" />
                                    </div>
                                    <div className="box-title-text has-actions">
                                        <h3 className="box-title">{tLang("manageAccount.myAccount.billing.address.title")}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`form-row inline row`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="sameAsContact"> {tLang("manageAccount.myAccount.billing.address.title")}</label>
                            </div>
                            <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <div className="form-row">
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="sameAsContact">
                                            <input type="checkbox" id="sameAsContact" name="sameAsContact" onChange={() => changeSameAsContactAddress()} checked={isSameAsContactAddress} />
                                            <span className="form-checkbox-label-text">{tLang("manageAccount.myAccount.billing.address.same")}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {!isSameAsContactAddress && (
                            <React.Fragment>
                                {/*<fieldset className="form-row no-margin inline">*/}
                                <div className="form-row no-margin inline row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <legend className="legend-label">
                                            <label htmlFor="label-address-line-1">
                                                {tLang("manageAccount.myAccount.billing.address.street")}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </legend>
                                    </div>

                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div role="alert" className={`form-row row ${errors["address1"] && "status-error"}`}>
                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                <label htmlFor="label-address-line1">
                                                    {tLang("manageAccount.myAccount.billing.address.address-1")}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                <input
                                                    type="text"
                                                    onChange={clearInvalidBillingAddress}
                                                    defaultValue={getAddress1()}
                                                    name="address1"
                                                    className="inputbox"
                                                    id="label-address-line-1"
                                                    ref={register({ required: true, pattern: PATTERNS.STREETADDRESS.pattern })}
                                                    placeholder="Address Line 1"
                                                    aria-required="true"
                                                />
                                                {errors["address1"] && errors["address1"].type === "required" && (
                                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.address1.required")}</span>
                                                )}
                                                {errors["address1"] && errors["address1"].type === "pattern" && (
                                                    <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div role="alert" className={`form-row row ${errors["address2"] && "status-error"}`}>
                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                <label htmlFor="label-address-line-2">{tLang("manageAccount.myAccount.billing.address.address-2")}</label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                <input
                                                    type="text"
                                                    onChange={clearInvalidBillingAddress}
                                                    defaultValue={getAddress2()}
                                                    name="address2"
                                                    className="inputbox"
                                                    id="label-address-line-2"
                                                    ref={register({ pattern: PATTERNS.STREETADDRESS.pattern })}
                                                    placeholder="Address Line 2 (Optional)"
                                                />
                                                {errors["address2"] && errors["address2"].type === "pattern" && (
                                                    <span className="form-error">{PATTERNS.STREETADDRESS.message}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*</fieldset>*/}
                                <div role="alert" className={`form-row inline row ${errors["city"] && "status-error"}`}>
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="label-address-city">
                                            {tLang("manageAccount.myAccount.billing.address.city")}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                        <input
                                            type="text"
                                            name="city"
                                            onChange={clearInvalidBillingAddress}
                                            defaultValue={getCity()}
                                            className="inputbox"
                                            id="label-address-city"
                                            ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                            placeholder="City"
                                            aria-required="true"
                                        />
                                        {errors["city"] && errors["city"].type === "required" && (
                                            <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.city.required")}</span>
                                        )}
                                        {errors["city"] && errors["city"].type === "pattern" && (
                                            <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.city.pattern")}</span>
                                        )}
                                    </div>
                                </div>
                                {country === "US" ? (
                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-address-state">
                                                {tLang("manageAccount.myAccount.billing.address.state")}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            <select
                                                className="inputbox"
                                                onChange={clearInvalidBillingAddress}
                                                id="label-address-state"
                                                defaultValue={getState()}
                                                name="state"
                                                ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                                aria-required="true"
                                            >
                                                {stateList.map((val: any) => (
                                                    <option key={val.name} value={val.value}>
                                                        {val.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors["state"] && errors["state"].type === "pattern" && (
                                                <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.state.required")}</span>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {country === "CA" ? (
                                            <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label htmlFor="label-address-state">
                                                        {tLang("manageAccount.myAccount.billing.address.province")}
                                                        <span className="required" title="Mandatory">
                                                            *
                                                        </span>
                                                    </label>
                                                </div>
                                                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                    <select
                                                        className="inputbox"
                                                        id="label-address-state"
                                                        onChange={clearInvalidBillingAddress}
                                                        name="state"
                                                        defaultValue={getState()}
                                                        ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                                        aria-required="true"
                                                    >
                                                        {CAProvinces.map((val: any) => (
                                                            <option key={val.name} value={val.value}>
                                                                {val.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors["state"] && errors["state"].type === "pattern" && (
                                                        <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.province.required")}</span>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                {billingInfo && (
                                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                            <label htmlFor="label-address-state">
                                                                {tLang("manageAccount.myAccount.billing.address.region")}
                                                                <span className="required" title="Mandatory">
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="state"
                                                                defaultValue={getState()}
                                                                ref={register({ required: true, pattern: PATTERNS.REGION.pattern })}
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                onChange={clearInvalidBillingAddress}
                                                                aria-required="true"
                                                            />
                                                            {errors["state"] && errors["state"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.billing.address.validations.region.required")}
                                                                </span>
                                                            )}
                                                            {errors["state"] && errors["state"].type === "pattern" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.billing.address.validations.region.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                                <div className={`form-row inline row ${errors["zipcode"] && "status-error"}`}>
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="label-address-zipcode">
                                            {zipCode.Label === "Zip Code"
                                                ? tLang("manageAccount.myAccount.billing.address.zip")
                                                : tLang("manageAccount.myAccount.billing.address.postalCode")}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span> &nbsp;
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                        <input
                                            type="text"
                                            onChange={clearInvalidBillingAddress}
                                            className="inputbox"
                                            id="label-address-zipcode"
                                            defaultValue={getZipCode()}
                                            name="zipcode"
                                            ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern })}
                                            maxLength={zipCode.MaxLength}
                                            placeholder={
                                                zipCode.Label === "Zip Code"
                                                    ? tLang("manageAccount.myAccount.billing.address.zip")
                                                    : tLang("manageAccount.myAccount.billing.address.postalCode")
                                            }
                                            aria-required="true"
                                        />
                                        {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                            <span className="form-error">
                                                {zipCode.Label === "Zip Code"
                                                    ? tLang("manageAccount.myAccount.billing.address.validations.zip.required")
                                                    : tLang("manageAccount.myAccount.billing.address.validations.postalCode.required")}
                                            </span>
                                        )}
                                        {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("manageAccount.myAccount.billing.address.validations.zip.invalid")} {zipCode.Label}{" "}
                                                {tLang("manageAccount.myAccount.billing.address.validations.zip.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-row inline row ${errors["phone"] && "status-error"}`}>
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="label-phone-number1">
                                            {tLang("manageAccount.myAccount.billing.address.phone")}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                        {billingInfo && (
                                            <>
                                                <Controller
                                                    name={`phone`}
                                                    control={control}
                                                    defaultValue={phoneNumber}
                                                    className="inputbox"
                                                    rules={{
                                                        required: true,
                                                        validate: (value) =>
                                                            value ? isValidPhoneNo(accountInfo && accountInfo.country ? accountInfo.country : "US", value) : false,
                                                    }}
                                                    render={({ onChange, value }) => (
                                                        <PhoneInput
                                                            value={value}
                                                            onChange={onChange}
                                                            international={false}
                                                            addInternationalOption={false}
                                                            className="inputbox"
                                                            defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                            countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                            id={"label-phone-number1"}
                                                            placeholder={tLang("manageAccount.myAccount.billing.address.placeholder.primaryPhone")}
                                                            maxLength={15}
                                                            minLength={10}
                                                            aria-required="true"
                                                        />
                                                    )}
                                                />
                                                {errors["phone"] && errors["phone"].type === "required" && (
                                                    <span className="form-error">{tLang("manageAccount.myAccount.billing.address.validations.phone.required")}</span>
                                                )}
                                                {errors["phone"] && errors["phone"].type === "validate" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText1")}{" "}
                                                        {watch("phone") && !parsePhoneNumber(watch("phone")) && (
                                                            <span>{tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText2")}</span>
                                                        )}
                                                        {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalidText3")}
                                                    </span>
                                                )}
                                                {errors["phone"] && errors["phone"].type === "minLength" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalid")}
                                                    </span>
                                                )}
                                                {errors["phone"] && errors["phone"].type === "maxLength" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.myAccount.billing.address.validations.phone.phoneNumberInvalid")}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        {errors["billingAddress"] && (
                            <fieldset role="alert" className="form-row inline">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <span className="form-error">{errors.billingAddress.message}</span>
                                    </div>
                                </div>
                            </fieldset>
                        )}

                        <div className="margin-vertical-l"></div>
                    </>
                )}

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowForm(false);
                                    }}
                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                >
                                    <span className="btn-text">Cancel</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button type="submit" className="btn-default btn-primary btn-min-width">
                                    <span className="btn-text">Save</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default IDFBillingInformationForm;
